import Axios from 'axios'
import router from '@/router'
import fileDownload from 'js-file-download'

export default {
    user: { authenticated: false },
    //авторизация и запись cookies
    authenticate(context, credentials, redirect) {
        Axios.post(`/api/v1/auth`, credentials)
            .then(({ data: { data } }) => {
                context.$cookie.set('token', data.token, { expires: '24h' })
                context.$cookie.setJSON('user_params', { admin: data.user.isAdmin, pagesize: data.user.pagesize, login: data.user.login, org: data.user.org, email: data.user.email }, { expires: '24h' })
                context.$cookie.set('expires', Date.now() + 60 * 60 * 24 * 1000, { expires: '24h' })
                context.$toast.success('Вы авторизованы', { duration: 3000 })
                this.user.authenticated = true
                if(context.$route.query.redirect){
                    router.push(decodeURIComponent(context.$route.query.redirect))
                }else{
                    if (redirect) router.push(redirect)
                }
            }).catch((error) => {
                console.log(error)
                if (error.code == "ERR_NETWORK") {
                    context.$toast.error('Ошибка сети '+error.message+'<br> Попробуйте обновить страницу', { duration: 3000 })
                }else if(error.response.data){
                    context.$toast.error(error.response.data.message, { duration: 3000 })
                }else{
                    context.$toast.error(error.message, { duration: 3000 })
                }
            })
    },
    signout(context, redirect) {
        context.$cookie.delete('token')
        context.$cookie.delete('user_id')
        context.$cookie.delete('user_params')
        context.$cookie.delete('expires')
        this.user.authenticated = false
        if (redirect) router.push(redirect)
    },
    //получить и распарсить куки
    getCookie(name) {
        let matches = document.cookie.match(new RegExp(
            "(?:^|; )" + name.replace(/([\\.$?*|{}\\(\\)\\[\\]\\\/\\+^])/g, '\\$1') + "=([^;]*)"
        ));
        return matches ? decodeURIComponent(matches[1]) : undefined;
    },
    //проверка на действительность сессии
    checkAuthentication() {
        this.user.authenticated = document.cookie && (this.getCookie('expires') > Date.now())
        return this.user.authenticated
    },
    rand() {
        return Math.random().toString(36).substr(2);
    },
    token() {
        return this.rand() + this.rand();
    },
    notAuth(context){
        context.$confirm(
            {
              message: 'Вы не авторизованы. <br> Перейти на страницу авторизации?',
              button: {
                no: 'Нет',
                yes: 'Да'
              },
              callback: confirm => {                            
                if (confirm) {
                    router.push('/lk?redirect='+encodeURIComponent(context.$route.fullPath))
                }
              }
            }
          )
    },
    async sendRequest(context, path, type, params = {}) {
        this.checkAuthentication()
        if (this.user.authenticated) {
            let config = {
                method: type,
                url: `${path}`,
                headers:
                {
                    'Authorization': `Bearer ${context.$cookie.get('token')}`,
                },
            }
            if (params) {
                config.data = params;
                if (params.filedata) {
                    let form_data = new FormData();
                    for (let key in params) {
                        form_data.append(key, params[key]);
                    }
                    config.data = form_data;
                }
                if (params.File) {
                    let form_data = new FormData();
                    for (let key in params) {
                        if (key != "File") {
                            if (Array.isArray(params[key])) {
                                form_data.append(key, JSON.stringify(params[key]));
                            } else {
                                form_data.append(key, params[key]);
                            }
                        }
                    }
                    form_data.append("file", params.File);
                    config.data = form_data;
                }
            }
            return Axios(config).catch(error => {
                console.log(error)
                if (error.status == 401) {
                    context.$cookie.delete('token')
                    context.$cookie.delete('user_id')
                    context.$cookie.delete('user_params')
                    context.$cookie.delete('expires')
                    this.user.authenticated = false
                    this.notAuth(context)
                } else if (error.code == "ERR_NETWORK") {
                    context.$toast.error('Ошибка сети '+error.message+'<br> Попробуйте обновить страницу', { duration: 3000 })
                }else{
                    context.$toast.error(error, { duration: 3000 })
                }
                return {
                    data:
                    {
                        succsess: false,
                        message: error
                    }
                }

            });
        } else {
            this.notAuth(context)            
            return {
                data:
                {
                    succsess: false,
                    message: 'Вы не авторизованы'
                }
            }
        }

    },
    async sendRequestNotAuth(context, path, type, params = {}) {
        let config = {
            method: type,
            url: `${path}`,
            headers:
            {
                'Content-Type': 'application/json; charset=utf-8'
            },
        }
        if (params) {
            config.data = params;
        }
        if (params) {
            config.data = params;
            if (params.filedata) {
                let form_data = new FormData();
                for (var key in params) {
                    form_data.append(key, params[key]);
                }
                config.data = form_data;
            }
        }
        return Axios(config).catch(error => {
            if (error.code == "ERR_NETWORK") {
                context.$toast.error('Ошибка сети '+error.message+'<br> Попробуйте обновить страницу', { duration: 3000 })
            }else{
                context.$toast.error(error, { duration: 3000 })
            }
            return {
                data:
                {
                    succsess: false,
                    message: error
                }
            }
        });
    },
    async axiosRequest(params) {
        return Axios(params).catch(error => {
            return {
                data:
                {
                    succsess: false,
                    message: error
                }
            }
        });
    },
    // получение файлов (через авторизацию)
    async sendRequestFileAuth(context, path, type, download, params = {}) {
        this.checkAuthentication()
        if (this.user.authenticated) {
            let config = {
                method: type,
                url: `${path}`,
                headers:
                {
                    'Authorization': `Bearer ${context.$cookie.get('token')}`,
                },
                responseType: 'blob'
            }
            if (params) {
                config.data = params;             
            }
            return Axios(config).then(res => {
                console.log("---")
                console.log(res)
                if (download){
                    return fileDownload(res.data, decodeURIComponent(res.headers["content-disposition"].split("filename=")[1].replace(/"/g, '')), res.headers["content-type"]);
                } else {
                    return {
                        data:
                        {
                            success: true,
                            url: URL.createObjectURL(res.data)
                        }
                    };
                }                
            }).
            catch(error => {                 
                console.log(error)
                if (error.status == 401) {
                    context.$cookie.delete('token')
                    context.$cookie.delete('user_id')
                    context.$cookie.delete('user_params')
                    context.$cookie.delete('expires')
                    this.user.authenticated = false
                    this.notAuth(context)
                } else if (error.code == "ERR_NETWORK") {
                    context.$toast.error('Ошибка сети '+error.message+'<br> Попробуйте обновить страницу', { duration: 3000 })
                }else{
                    return {
                        data:
                        {
                            succsess: false,
                            message: 'Ошибка загрузки файла',
                            error: error
                        }
                    }
                }
                
            });
        } else {
            this.notAuth(context)            
            return {
                data:
                {
                    succsess: false,
                    message: 'Вы не авторизованы'
                }
            }
        }

    },
}
